// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var subTitle = "ProductPage-module--subTitle--1t1Gp";
export var info = "ProductPage-module--info--aEPcp";
export var label = "ProductPage-module--label--1M-KO";
export var container = "ProductPage-module--container--2-jRv";
export var leftSide = "ProductPage-module--leftSide--2GTEn";
export var rightSide = "ProductPage-module--rightSide--2936s";
export var featuresSectionContainer = "ProductPage-module--featuresSectionContainer--ihC7t";
export var topLeftSide = "ProductPage-module--topLeftSide--2GWaZ";
export var image = "ProductPage-module--image--17qNR";
export var topRightSide = "ProductPage-module--topRightSide--3JWoH";
export var featuresContainerWrapper = "ProductPage-module--featuresContainerWrapper--1DPRv";
export var featuresContainer = "ProductPage-module--featuresContainer--3fPU3";
export var feature = "ProductPage-module--feature--3CN3p";
export var certifications = "ProductPage-module--certifications--1LNNI";
export var certificationLogo = "ProductPage-module--certificationLogo--18rnA";
export var organicTagContainerMobile = "ProductPage-module--organicTagContainerMobile--3vNsc";
export var organicTagContainer = "ProductPage-module--organicTagContainer--2iGYF";
export var organicTagIcon = "ProductPage-module--organicTagIcon--2wr2F";
export var organicTag = "ProductPage-module--organicTag--3xk2s";
export var toxicologicalSection = "ProductPage-module--toxicologicalSection--a0nlt";
export var pictogramsContainer = "ProductPage-module--pictogramsContainer--2LRaS";
export var pictogram = "ProductPage-module--pictogram--gdpTw";
export var ghsCodesSection = "ProductPage-module--ghsCodesSection--2htND";
export var ghsCodeAndDescription = "ProductPage-module--ghsCodeAndDescription--1ft_X";
export var codeContainer = "ProductPage-module--codeContainer--145o7";
export var code = "ProductPage-module--code--2p1o0";
export var descriptionContainer = "ProductPage-module--descriptionContainer--2_TSv";
export var hiddenCodesInfo = "ProductPage-module--hiddenCodesInfo--kvH8d";
export var emergencySection = "ProductPage-module--emergencySection--1w-Bm";
export var emergencyInfoContainer = "ProductPage-module--emergencyInfoContainer--29tjn";
export var emergencyIconContainer = "ProductPage-module--emergencyIconContainer--VrcTa";
export var emergencyInfo = "ProductPage-module--emergencyInfo--1cywi";
export var emergency = "ProductPage-module--emergency--2M-O4";
export var emergencyContentInfo = "ProductPage-module--emergencyContentInfo--9uh7K";
export var applicationsContainer = "ProductPage-module--applicationsContainer--rMjnL";
export var application = "ProductPage-module--application--3fSKS";
export var problemContainer = "ProductPage-module--problemContainer--9fj7v";
export var problemBlock = "ProductPage-module--problemBlock--rWaue";
export var scientificName = "ProductPage-module--scientificName--l76KJ";
export var problemObservation = "ProductPage-module--problemObservation--25gDF";
export var applicationsContainerFR = "ProductPage-module--applicationsContainerFR--2nfws";
export var cropInfo = "ProductPage-module--cropInfo--30wUo";
export var applicationsFRMoreInformation = "ProductPage-module--applicationsFRMoreInformation--1wuje";
export var infoFR = "ProductPage-module--infoFR--5-z4L";
export var otherDocumentsContainer = "ProductPage-module--otherDocumentsContainer--1wEs5";
export var relatedProductsContainer = "ProductPage-module--relatedProductsContainer--GxHyF";
export var cardLinkWrapper = "ProductPage-module--cardLinkWrapper--3_sSW";
export var mockEvent = "ProductPage-module--mockEvent--1SesQ";
export var disclaimerContainer = "ProductPage-module--disclaimerContainer--6qep1";
export var disclaimerLink = "ProductPage-module--disclaimerLink--1e-Ol";
export var documentsContainerFullWidth = "ProductPage-module--documentsContainerFullWidth--1oMgA";
export var formulationTypeRightSide = "ProductPage-module--formulationTypeRightSide--2hCeE";
export var videosWrapper = "ProductPage-module--videosWrapper--N1fSe";
export var newsWrapper = "ProductPage-module--newsWrapper--2Ej1p";
export var imagesWrapper = "ProductPage-module--imagesWrapper--X2CpI";
export var video = "ProductPage-module--video--3GJj-";
export var news = "ProductPage-module--news--2JKsI";
export var imageContainer = "ProductPage-module--imageContainer--37G1T";
export var videoTitle = "ProductPage-module--videoTitle--1duH4";
export var videoDescription = "ProductPage-module--videoDescription--7Swol";
export var documentsContainer = "ProductPage-module--documentsContainer--37sKL";
export var formulationTypeLeftSide = "ProductPage-module--formulationTypeLeftSide--1WJ3-";
export var unstructuredContent = "ProductPage-module--unstructuredContent--24CUq";